import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[injection-point]'
})
export class ShInjectionPointDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
